﻿$.fn.dxCtrlDomaineDedieResume = function custom_dxCtrlDomaineDedieResume(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrldomainededieresume dx-ctrl");
        this.createInstance(new cdxCtrlDomaineDedieResume(this, option));
    }
    return this;
}

window.cdxCtrlDomaineDedieResume = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty();
    }

    this.element = function () { return container }

    mConstruit();
}